import { ActionIcon, Tooltip } from "@mantine/core";
import { IconRefresh } from "@tabler/icons-react";

interface RegenerateSecretButtonProps {
  disabled?: boolean;
  label?: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
}

function RegenerateSecretButton({
  disabled,
  label = "Client Secret neu generieren",
  onClick
}: RegenerateSecretButtonProps) {
  return (
    <Tooltip label={label}>
      <ActionIcon
        aria-label={label}
        color="error"
        disabled={disabled}
        size="xs"
        variant="transparent"
        onClick={onClick}
      >
        <IconRefresh
          className="regenerate-secret-icon"
          data-testid="icon-button-regenerate-secret"
        />
      </ActionIcon>
    </Tooltip>
  );
}

export { RegenerateSecretButton, RegenerateSecretButtonProps };
